let station = {
  name: 'STATION',
};

let engine = {
  STATE: {IDLE: 0, PREPARE: 1, CRUISE: 2, WORK: 3, STANDBY: 4},
  engines: [],
  types: [],
  mappedTypes: {}
};

export default {
  ...station,
  reset: function () {
    engine.engines.splice(0);
    engine.types.splice(0);
    for (let key in engine.mappedTypes) {
      delete engine.mappedTypes[key];
    }
  },
  engine: {
    ...engine,
    stateNames: {
      0: '空闲',
      1: '准备',
      2: '巡航',
      3: '工作',
      4: '待命',
    },
    setupType: function (type, flow, capacity, speed, prepare, cost, amount) {
      let engineType = {type, flow, capacity, speed, prepare, cost, amount};
      engine.types.push(engineType);
      engine.mappedTypes[type] = engineType;
    },
    copyType: function (typeName) {
      let raw = typeName;
      let type = engine.types.find(type => type.type === typeName);
      let index = engine.types.findIndex(type => type.type === typeName);
      let rawMatcher = typeName.match(/-\d+$/);
      if (rawMatcher) {
        raw = typeName.substring(0, rawMatcher.index);
      }
      let regex = new RegExp(raw + '(-\\d+)?$');
      let maxSeries = engine.types.filter(type => regex.test(type.type)).length;
      engine.types.forEach(function (type) {
        let matcher = type.type.match(regex);
        if (matcher && matcher.length > 1 && matcher[1]) {
          let series = Number(matcher[1].substring(1));
          if (series > maxSeries) {
            maxSeries = series
          }
        }
      });
      type = {...type, type: raw + '-' + (maxSeries + 1)};
      engine.types.splice(index + 1, 0, type);
      engine.mappedTypes[type.type] = type;
      return type.type;
    },
    dropType: function (typeName) {
      engine.types.splice(engine.types.findIndex(type => type.type === typeName), 1)
    },
    buildInstance: function (type) {
      let typedInstance = engine.engines.filter(instance => instance.type === type);
      let regex = new RegExp(type + '(-\\d+)?$');
      let maxSeries = typedInstance.length;
      typedInstance.forEach(function (instance) {
        let matcher = instance.name.match(regex);
        if (matcher && matcher.length > 1 && matcher[1]) {
          let series = Number(matcher[1].substring(1));
          if (series > maxSeries) {
            maxSeries = series
          }
        }
      });
      let name = type + '-' + String((maxSeries + 1) / 1000).substring(2);
      engine.engines.push({
        name,
        state: engine.STATE.IDLE,
        cruise: {src: '', dst: ''},
        elapsed: 0,
        ...engine.mappedTypes[type]
      });
      return name;
    }
  }
}
